import * as types from '../constants/ActionTypes';

const initialState = {
  elmoTreatments: [],
  receivedResponse: false,
  isElmoLoading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.ELMO_EXPERIMENTS_REQUESTED:
      return { ...state, receivedResponse: false, isElmoLoading: true };
    case types.ELMO_EXPERIMENTS_RECEIVED:
      return {
        ...state,
        elmoTreatments: [...state.elmoTreatments, ...action.payload],
        receivedResponse: true,
        isElmoLoading: false,
      };
    case types.ELMO_EXPERIMENTS_ERROR:
      return {
        ...state,
        elmoTreatments: [...state.elmoTreatments],
        receivedResponse: false,
        isElmoLoading: false,
      };
    default:
      return state;
  }
}
